module.exports = __webpack_public_path__ + "static/media/starshipit5.e25c2535.jpg";